var PermissionKeys = {
  STUDENT_ADD: "student_add",
  STUDENT_EDIT: "student_edit",
  STUDENT_DELETE: "student_delete",
  STUDENT_DETAILS: "student_details",
  STUDENT_LIST: "student_list",
  STUDENT_CONTACT_ADD: "student_contact_add",
  STUDENT_CONTACT_EDIT: "student_contact_edit",
  STUDENT_CONTACT_DELETE: "student_contact_delete",
  STUDENT_CONTACT_DETAILS: "student_contact_details",
  STUDENT_CONTACT_LIST: "student_contact_list",
  STUDENT_ADD_ENROLLMENT: "student_add_enrollment",
  STUDENT_ENROLLMENT_DETAILS: "student_enrollment_details",
  STUDENT_ADD_TEAM: "student_add_team",
  STUDENT_GOAL_LIST: "student_goal_list",
  STUDENT_GOAL_ADD: "student_goal_add",
  STUDENT_ALL_SERVICES_LIST: "student_all_services_list",
  STUDENT_SERVICE_STEP_DETAILS: "student_service_step_details",
  STUDENT_SERVICE_BATCH_ADD: "student_service_batch_add",
  CLIENT_MEMBER_LIST: "client_member_list",
  CLIENT_MEMBER_DETAILS: "client_member_details",
  CLIENT_MEMBER_STUDENTS_LIST: "client_member_students_list",
  STUDENT_GOAL_DETAILS: "student_goal_details",
  STUDENT_GOAL_ADD_COMMENT: "student_goal_add_comment",
  CLIENT_USER_TASK_ADD: "client_user_task_add",
  CLIENT_USER_TASK_LIST: "client_user_task_list",
  CLIENT_USER_TASK_DETAILS: "client_user_task_details",
  SERVICE_CREATE: "service_create",
  USER_DETAILS: "user_details",
  CLIENT_USER_TASK_ADD_COMMENT: "client_user_task_add_comment",
  SERVICE_STEPS_LIST: "service_step_list",
  CLIENT_USERS_LIST: "client_users_list",
  CLIENT_SERVICE_STEP_DETAILS: "client_service_step_details",
  CLIENT_USER_ADD: "client_user_add",
  BATCH_CREATE: "batch_create",
  BATCH_DETAILS: "batch_details",
  BATCH_LIST: "batch_list",
  SERVICE_LIST: "service_list",
  SERVICE_DETAILS: "service_details",
  MESSAGE_ADD: "message_add",
  MESSAGE_THREAD_CREATE: "message_thread_create",
  MESSAGE_THREAD_LIST: "message_thread_list",
  MESSAGE_THREAD_DETAILS: "message_thread_details",
  STUDENT_GOAL_EDIT: "student_goal_edit",
  CLIENT_USER_TASK_EDIT: "client_user_task_edit",
  STEP_COMMENT_ADD: "step_comment_add",
  STEP_STATUS_UPDATE: "step_status_update",
  STUDENT_SERVICE_STEP_ADD: "student_service_step_add",
  STUDENT_SERVICE_STEP_EDIT: "student_service_step_edit",
  STUDENT_SERVICE_STEP_SUBMISSION_DELETE:
    "student_service_step_submission_delete",
  STUDENT_SERVICE_STEP_SUBMISSION_ADD: "student_service_step_submission_add",
  STUDENT_SERVICE_STEP_COMMENT_ADD: "student_service_step_comment_add",
  STUDENT_GOAL_EDIT_COMMENT: "student_goal_edit_comment",
  STUDENT_GOAL_DELETE_COMMENT: "student_goal_delete_comment",
  STUDENT_SERVICE_STEP_REORDER: "student_service_step_reorder",

  DASHBOARD_ACTIONS_LIST: "dashboard_actions_list",
  DASHBOARD_STEPS_LIST: "dashboard_steps_list",
  DASHBOARD_KPI: "dashboard_kpi",
  SERVICE_PROVIDER_ADD: "service_provider_add",
  SERVICE_PROVIDER_EDIT: "service_provider_edit",
  SERVICE_PROVIDER_DETAILS: "service_provider_details",
  SERVICE_PROVIDER_DELETE: "service_provider_delete",
  SERVICE_PROVIDER_LIST: "service_provider_list",
  MASTERS_DATA: "masters_data",
  MASTERS_SERVICES: "master_services",
  MASTERS_CLIENTS: "masters_clients",
  CLIENTS_LIST: "clients_list",
  CLIENT_ADD: "client_add",
  CLIENT_EDIT: "client_edit",

  RESOURCES: "resources",
  MY_RESOURCES_LIST: "my_resources_list",
  ALL_RESOURCES_LIST: "all_resources_list",
  RESOURCE_MANAGEMENT: "resource_management",
  BOOKMARKED_RESOURCES: "bookmarked_resources",
  RESOURCE_ADD: "resource_add",
  RESOURCE_EDIT: "resource_edit",
  RESOURCE_DELETE: "resource_delete",
  RESOURCE_DETAILS: "resource_details",

  STUDENT_RESOURCE_ADD: "student_resource_add",
  STUDENT_RESOURCE_LIST: "student_resource_list",

  STUDENT_COMMENT_ADD: "student_comment_add",
  STUDENT_COMMENT_EDIT: "student_comment_edit",
  STUDENT_COMMENT_DELETE: "student_comment_delete",
  STUDENT_COMMENT_LIST: "student_comment_list",

  RESOURCE_APPROVAL_COMMENT_ADD: "resource_approval_comment_add",
  RESOURCE_APPROVAL_COMMENT_EDIT: "resource_approval_comment_edit",
  RESOURCE_APPROVAL_COMMENT_LIST: "resource_approval_comment_list",
  STUDENT_FREEMIUM_ADD: "student_freemium_add",

  EBLITY_ADMIN_ADD: "eblity_admin_add",

  EBLITY_ADMIN_LIST: "eblity_admin_list",

  CLIENT_MASTER_GRADE_DETAILS: "client_masters_grade_details",
  CLIENT_MASTERS_ROLE_DETAILS: "client_masters_role_details",
  CLIENT_MASTERS_CLASS_DETAILS: "client_masters_class_details",
  CLIENT_MASTERS_REFERRAL_RELATION_DETAILS:
    "client_masters_referral_relation_details",

  CLIENT_MASTERS_CLASS_ADD: "client_masters_class_add",
  CLIENT_MASTERS_CLASS_EDIT: "client_masters_class_edit",
  CLIENT_MASTERS_CLASS_DELETE: "client_masters_class_delete",

  CLIENT_MASTERS_GRADE_ADD: "client_masters_grade_add",
  CLIENT_MASTERS_GRADE_EDIT: "client_masters_grade_edit",
  CLIENT_MASTERS_GRADE_DELETE: "client_masters_grade_delete",

  CLIENT_MASTERS_ROLE_ADD: "client_masters_role_add",
  CLIENT_MASTERS_ROLE_EDIT: "client_masters_role_edit",
  CLIENT_MASTERS_ROLE_DELETE: "client_masters_role_delete",

  CLIENT_MASTERS_REFERRAL_RELATION_ADD: "client_masters_referral_relation_add",
  CLIENT_MASTERS_REFERRAL_RELATION_EDIT:
    "client_masters_referral_relation_edit",
  CLIENT_MASTERS_REFERRAL_RELATION_DELETE:
    "client_masters_referral_relation_delete",
  CLIENT_DETAILS: "client_details",

  SERVICE_STEP_LIST: "service_step_list",
  CLIENT_MASTERS_SERVICE_ADD: "client_masters_service_add",
  CLIENT_MASTERS_SERVICE_EDIT: "client_masters_service_edit",

  CLIENT_MASTERS_STEP_ADD: "client_masters_step_add",
  CLIENT_MASTERS_STEP_EDIT: "client_masters_step_edit",

  MASTERS_SERVICE_DETAILS: "masters_service_details",
  MASTERS_STEP_DETAILS: "masters_step_details",

  CLIENT_MASTERS_SETTINGS: "client_masters_settings",
};

const MASTERS_MODULES = [
  "city",
  "client_type",
  "country",
  "gender",
  "grade",
  "group",
  "group_permission",
  "key_value",
  "payment_mode",
  "permission",
  "referral_relation",
  "relation_type",
  "role",
  "service_goal_type",
  "state",
  "task_type",
  "age_group",
  "resource_language",
  "resource_type",
  "skill",
  "tag",
  "referral_relation",
  "class",
  "user_group",
  "service",
  "step",
];
const actions = ["add", "edit", "delete", "details"];

MASTERS_MODULES.forEach((module) => {
  actions.forEach((action) => {
    PermissionKeys[
      "MASTERS_" + module.toUpperCase() + "_" + action.toUpperCase()
    ] = "masters_" + module + "_" + action;
  });
});

export default PermissionKeys;
